import SWC from "components/Stacker/constants/SwatchConstants"

export const initialState = {}

export default function swatchReducer(previousState = initialState, action) {
  switch (action.type) {
    case SWC.SWATCH_SELECTED:
      return {
        ...previousState,
        [action.payload.baseProductCode]: action.payload,
      }
    default:
      return previousState
  }
}
